// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestionCard-cls1__f36fd6d77f25ba92e8d6","cls2":"SuggestionCard-cls2___8f880b91086740969a7 SuggestionCard-cls1__f36fd6d77f25ba92e8d6"};